module.exports = "/assets/diamondsvg-eb58f44ae9ab5eaf5c6a50561fb360d0.svg";